<template lang="pug">
  .component-backoffice-client-list.row.column
    cards(:data="parsedReports")
    client-list-form(@setSearch="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import InputForm from 'components/structure/ui/filters/InputForm'
  import BaseList from './BaseList'
  import HeaderColumns from 'components/structure/ui/HeaderColumns'
  import Cards from 'components/structure/Cards'
  import ClientListForm from '../../components/structure/ui/filters/ClientListForm'

  export default {
    name: 'ClientList',
    components: {
      ClientListForm,
      Cards,
      HeaderColumns,
      BaseList,
      InputForm,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Client.vue'),
        reports: null,
        search: {
          status: 'ACTIVE'
        }
      }
    },
    created() {
      var start = this.$date().startOf('month').format('Y-MM-DD')
      var end = this.$date().endOf('month').format('Y-MM-DD')
      KeplerBackofficeSdk.reports.list({start: start, end: end}).clients((data) => {
        this.reports = data
      })
    },
    methods: {
      setSearch(search) {
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        // We have the input-form compiled?
        if (search && (search.query || search.balance)) {
          if (this.$isset(search.query)) {
            KeplerBackofficeSdk.clients.list(page, resultsPerPage, search).search((items) => {
              callback(items)
            })
          }
        } else {
          KeplerBackofficeSdk.clients.list(page, resultsPerPage, search).all((data) => {
            callback(data)
          })
        }
      },
      getReports(range) {
        this.reports = null
        KeplerBackofficeSdk.reports.list(range).clients((data) => {
          this.reports = data
        })
      },
    },
    computed: {
      parsedReports: function () {
        if (!this.reports) {
          return []
        }

        return [
          {
            title: 'Active clients',
            value: this.reports.total_active_clients
          },
          {
            title: 'On hold clients',
            value: this.reports.total_on_hold_clients
          },
          {
            title: 'Suspended clients',
            value: this.reports.total_suspended_clients
          },
        ]
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// ClientList.vue?64802bde